import { render, staticRenderFns } from "./WebsocketNotification.vue?vue&type=template&id=051ccb9e&scoped=true&"
import script from "./WebsocketNotification.vue?vue&type=script&lang=js&"
export * from "./WebsocketNotification.vue?vue&type=script&lang=js&"
import style0 from "./WebsocketNotification.vue?vue&type=style&index=0&id=051ccb9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051ccb9e",
  null
  
)

export default component.exports